import { FaRoute, FaChartLine, FaRobot, FaShieldAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const TechnologySection = () => {
  const technologies = [
    {
      id: 1,
      icon: <FaRoute size={36} />,
      title: 'Real-Time Tracking',
      description: 'Monitor your shipments in real-time with our advanced GPS tracking system, providing accurate location updates and estimated arrival times.'
    },
    {
      id: 2,
      icon: <FaChartLine size={36} />,
      title: 'Route Optimization',
      description: 'Our intelligent algorithms calculate the most efficient routes, reducing transit times and minimizing fuel consumption for a greener footprint.'
    },
    {
      id: 3,
      icon: <FaRobot size={36} />,
      title: 'AI-Powered Solutions',
      description: 'Leveraging artificial intelligence to predict potential delays, optimize warehouse operations, and enhance overall logistics efficiency.'
    },
    {
      id: 4,
      icon: <FaShieldAlt size={36} />,
      title: 'Secure Logistics',
      description: 'Advanced security protocols and blockchain technology ensure the integrity and safety of your shipments throughout the entire supply chain.'
    }
  ];

  return (
    <section className="py-16 bg-white dark:bg-secondary-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 text-secondary-900 dark:text-white">Powered by Advanced Technology</h2>
          <p className="max-w-2xl mx-auto text-secondary-600 dark:text-secondary-300">
            Our cutting-edge technology stack enables us to deliver faster, smarter, and more reliable logistics solutions for your business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {technologies.map((tech) => (
            <motion.div 
              key={tech.id}
              className="flex p-6 bg-secondary-50 dark:bg-secondary-700 rounded-lg shadow-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="mr-5 text-primary-600 dark:text-primary-400 flex-shrink-0">
                {tech.icon}
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-secondary-900 dark:text-white">
                  {tech.title}
                </h3>
                <p className="text-secondary-600 dark:text-secondary-300">
                  {tech.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;